/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../controls.module.ts' />
//let ScanditSDK: any;

module Meevo.Components.Controls {
    'use strict';
    export enum BarcodeScanners {
        Quagga = 0,
        //Scandit = 1
    }

    export enum BarcodeScanModes {
        File = 1,
        Camera = 2,
        Device = 3
    }

    class MeevoBarcodeScanner implements ng.IComponentController {
        static $inject = [
            '$scope',
            '$q',
            '$timeout'
        ];
        //#region bindings
        public scannerElement: string;
        public draggable: boolean;
        public isModal: boolean;
        public currentInventoryType: Meevo.Model.ProductInventoryTypeEnum;
        public savedInventoryType: Meevo.Model.ProductInventoryTypeEnum;
        public onScan: (codes) => {};
        public onDestroy: (isModal) => {};
        public onInventoryTypeChange: (currentInventoryType) => {};
        public onBarcodeScanModeChange: (scanMode) => {};
        //#endregion bindings

        private decodeOrder: Array<string> = ['small', 'medium', 'large', 'x-large', 'x-small'];
        
        scanMode: BarcodeScanModes = BarcodeScanModes.Device;
        localStorageKey: string;
        localStorageCodeSuffix: string;
        beepSound: HTMLAudioElement;
        failSound: HTMLAudioElement;
        dingSound: HTMLAudioElement;
        activeCamera: number;
        cameras: any;
        scannerLoaded: boolean = false;
        defaultOptions: { readers: string[]; camera: any; showBox: boolean; showLine: boolean; mode: BarcodeScanModes };
        showSettingsCheckMessage: boolean;
        readers: any;
        localStorageItem: any = {};
        barImage: any;
        barcodeLookups: any;
        public cameraAccess: boolean = null;
        public isFocused: boolean = false;

        constructor(private $scope: ng.IScope, private $q: ng.IQService, private $timeout: ng.ITimeoutService) {
                console.log("BARCODE SCANNER DIRECTIVE", $scope);

                $scope.$on('$destroy', () => { 
                    console.log('=========BARCODE SCANNER ONDESTROY======');
                    this.closeQuagga();
                });
        }
        
        $onInit(): void {
            this.localStorageKey = 'meevo2.barcode-scanner';
            this.localStorageCodeSuffix = ".codes";
            this.beepSound = new Audio("assets/audio/beep.mp3");
            this.failSound = new Audio("assets/audio/fail.mp3");
            this.dingSound = new Audio("assets/audio/ding.mp3");
            this.activeCamera = 0;
            this.cameras;            
            this.defaultOptions = {
                readers: ["upc_reader","code_128_reader","code_39_reader"],
                camera: null,
                showBox: true,
                showLine: true,
                mode: BarcodeScanModes.Device
            }

            this.showSettingsCheckMessage = false;

            sessionStorage.removeItem(this.localStorageKey + this.localStorageCodeSuffix);

            this.getLocalStorageValues();
            if (this.localStorageItem.mode) {
                this.scanMode = this.localStorageItem.mode;
            }
            this.barcodeScanModeChange();
            
            if (this.localStorageItem.mode == BarcodeScanModes.Camera) {
                this.openScanner();
            } else {
                this.focusImportTextarea();
            }
            this.scannerLoaded = true;
            
        }

        get isCameraMode() : boolean {
            return this.scanMode == BarcodeScanModes.Camera;
        }

        get isDeviceMode() : boolean {
            return this.scanMode == BarcodeScanModes.Device;
        }

        get isFileMode() : boolean {
            return this.scanMode == BarcodeScanModes.File;
        }
           
        revertToDefaultReaders = () => {
            this.readers = this.defaultOptions.readers
            this.localStorageItem[0] = this.readers;
            this.saveLocalStorageItem();
        }
        
        getLocalStorageValues = () => {
            var json : any = {};
            try {
                json = JSON.parse(localStorage.getItem(this.localStorageKey));
                this.readers = json.readers;
            } catch (e) { }
            
            if (!this.readers) {
                this.readers = this.defaultOptions.readers;
            }
            this.localStorageItem = json || {};
        }

        initializeCamera = () => {
            try {
                if (this.localStorageItem.camera) {
                    var ndx = this.cameras.findIndex(x => x.deviceId == this.localStorageItem.camera.deviceId);
                    this.activeCamera = ndx > -1 ? ndx : 0;
                }
            } catch (error) {
                this.localStorageItem = this.defaultOptions;
                this.readers = this.defaultOptions.readers
            }
        }

        openScanner = () => {
            try {
                this.$timeout(() => {
                    this.openQuagga();
                }, 1);    
            } catch (e) {
                console.log('----error opening scanner----', e)
            }
        }

        selectAllReaders = () => {
            if (Object.keys(this.barcodeReadersQuagga).length == this.readers.length) {
                this.readers = [];
            } else {
                this.readers = Object.keys(this.barcodeReadersQuagga);
            }
        }

        openNewBrowserTab = (e, url) => {
            e.stopPropagation();
            window.open(url, 'barcode-wiki');
        }

        showInventoryTypeToggle = () => {
            return !this.isDeviceMode && this.savedInventoryType == Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply 
                && (this.currentInventoryType == Meevo.Model.ProductInventoryTypeEnum.Retail
                || this.currentInventoryType == Meevo.Model.ProductInventoryTypeEnum.ShopSupply);
        }

        switchCameras = () => {
            if (this.activeCamera < this.cameras.length - 1) {
                this.activeCamera++;
            } else {
                this.activeCamera = 0;
            }
            this.localStorageItem.camera = this.cameras[this.activeCamera];
            this.saveLocalStorageItem();
            this.closeQuagga();
            this.initQuagga();
        }

        saveLocalStorageItem = () => {
            try {
                localStorage.setItem(this.localStorageKey, JSON.stringify(this.localStorageItem));    
            } catch (error) { }
        }

        swipedLeft = () => {
            if (!this.draggable) {
                this.closeButtonClicked();
            }
        }

        closeButtonClicked = () => {
            this.$timeout(() => {
                this.closeScanner();    
            });
        }

        closeScanner = () => {
            this.closeQuagga();
            this.scannerLoaded = false;
            const container = document.querySelector(`#${this.scannerElement}-barcode-scanner`);
            if (container) {
                this.removeAllChildNodes(container);
            }
            this.onDestroy({isModal:this.isModal == true});
        }        

        closeQuagga = () => {
            try {
                this.barcodeStream.getTracks().forEach(function(track) {
                    track.stop();
                });
                Quagga.offDetected(this.quaggaDetectedHandler);
                Quagga.stop();
            } catch (error) { }
        }

        openReaderMenu = (e) : void => {
            e.stopPropagation();
            e.preventDefault();
            this.$timeout(() => {
                $("#barcode-readers-select").click();    
            }, 1);
        }

        getReaderValue = (item) : string => {
            console.log('get reader value', item);
            return Object.keys(item)[0];
        }

        barcodeReaderChange = () : void => {
            this.$timeout(() => {
                if (this.localStorageItem) {
                    this.localStorageItem.readers = this.readers;
                }
                this.saveLocalStorageItem();
                
                console.log('initialize Quagga', Quagga);
                Quagga.setReaders(this.readers);
                $('#barcode-readers-select').blur();
            }, 1);
        }

        toggleFocus = (focused: boolean) : void => {
            this.isFocused = focused;
        }

        public barcodeReadersQuagga = {
            "upc_reader": {
                "label": "Univeral Product Code (UPC-A)",
                "url": "https://en.wikipedia.org/wiki/Universal_Product_Code"
            },
            "upc_e_reader": {
                "label": "Univeral Product Code (UPC-E)",
                "url": "https://en.wikipedia.org/wiki/Universal_Product_Code"
            },
            "ean_reader": {
                "label": "European Article Number",
                "url": "https://en.wikipedia.org/wiki/International_Article_Number"
            },
            "ean_8_reader": {
                "label": "EAN-8",
                "url": "https://en.wikipedia.org/wiki/EAN-8"
            },
            "code_128_reader": {
                "label": "Code 128",
                "url": "https://en.wikipedia.org/wiki/Code_128"
            },
            "code_39_reader": {
                "label": "Code 39",
                "url": "https://en.wikipedia.org/wiki/Code_39"
            },
            "code_39_vin_reader": {
                "label": "Code 39 VIN",
                "url": "https://en.wikipedia.org/wiki/Code_39"
            },
            "code_93_reader": {
                "label": "Code 93",
                "url": "https://en.wikipedia.org/wiki/Code_93"
            },
            "codabar_reader": {
                "label": "Codabar",
                "url": "https://en.wikipedia.org/wiki/Codabar"
            },
            "i2of5_reader": {
                "label": "Interleaved 2 of 5 (ITF)",
                "url": "https://en.wikipedia.org/wiki/Interleaved_2_of_5"
            },
            "2of5_reader": {
                "label": "Two-out-of-five code",
                "url": "https://en.wikipedia.org/wiki/Two-out-of-five_code"
            }
        }
        
        quaggaDetectedHandler = (result) => {
            if (result && result.codeResult) {
                var foundCode = result.codeResult.code
                this.processFoundBarcode(foundCode);
            }
        }

        openQuagga = () => {
            console.log('initialize Quagga', Quagga)

            this.$timeout(() => {
                if (!this.cameraAccess) {
                    this.showSettingsCheckMessage = true;
                }
            }, 5000);

            this.$timeout(() => {
                Quagga.CameraAccess.enumerateVideoDevices().then((cameras) => {
                    console.log('found cameras', cameras)
                    if (cameras && cameras.length == 0) {
                        this.handleCameraAccessFail();
                    } else {
                        this.cameras = cameras;
                        this.initializeCamera();
                        this.initQuagga();
                    }                    
                }).catch((e) => {
                    console.log('---error enumerating cameras---', e);
                    this.handleCameraAccessFail();
                });
            }, 1);
                                
            Quagga.onDetected(this.quaggaDetectedHandler);

            Quagga.onProcessed(result => {
                var drawingCtx = Quagga.canvas.ctx.overlay, drawingCanvas = Quagga.canvas.dom.overlay;
                if (!result) {
                    
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    
                    return;
                }

                if (result.boxes) {
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    result.boxes.filter((box) => {
                        return box !== result.box;
                    }).forEach(box => {
                        Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "#3d3d3d", lineWidth: 2});
                    });
                }

                if (result.box) {
                    Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#3d3d3d", lineWidth: 2});
                }

                if (result.codeResult && result.codeResult.code) {
                    Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: '#fefefe', lineWidth: 3});
                }

            });
            
        }

        barcodeStream: MediaStream;
        initQuagga = () => {
            try {
                let { deviceId } = this.localStorageItem.camera || this.cameras[this.activeCamera];
                var el = document.getElementById((this.scannerElement ? this.scannerElement + '-' : '') + 'barcode-scanner');
                if (!el) return;
                navigator.mediaDevices.getUserMedia({ video: { deviceId: deviceId } }).then((stream) => {
                    console.log('====barcode stream====', stream);
                    this.barcodeStream = stream;
                    this.initQuaggaFn(el, deviceId);

                }).catch((e) => {
                    this.handleCameraAccessFail();

                });
            } catch (e) {
                this.cameraAccess = false;
            }
                        
        }

        initQuaggaFn = (el, deviceId) => {
            
            Quagga.init({
                frequency: 5,
                inputStream : {
                    constraints: {
                        width: 640,
                        height: 345,
                        deviceId,
                        },
                    name : "Live",
                    type : "LiveStream",
                    area: {
                        top: "0%",
                        right: "0%",
                        left: "0%",
                        bottom: "0%",
                    },
                    target: el
                },
                numOfWorkers: window.navigator.hardwareConcurrency || 2,
                debug: true,
                decoder : {
                    readers : this.readers,
                    debug: {
                        drawBoundingBox: true,
                        drawScanline: true,
                    },
                }
            }, (err) => {
                if (err) {
                    this.switchCameras();
                    return;
                }
                console.log("Initialization finished. Ready to start");
                this.cameraAccess = true;
                
                this.$timeout(() => {
                    this.scannerLoaded = true;
                    window.dispatchEvent(new Event('resize'));
                }, 1000);
                Quagga.start();
            });
        }

        handleCameraAccessFail = () => {
            this.$timeout(() => {
                this.getLocalStorageValues();
                this.cameraAccess = false;
                this.scannerLoaded = true;
            }, 1);
        }

        focusImportTextarea() : void {
            this.$timeout(() => {
                var el = document.getElementById("barcode-import-textarea");
                if (el) {
                    el.focus();
                }
            }, 750);
        }

        switchMode = (type: string) => {
            this.barImage = null;
            switch(type) {
                case 'file':
                    this.scanMode = BarcodeScanModes.File;
                    this.$timeout(() => {
                        this.closeQuagga();
                    },1);
                    this.$timeout(() => {
                        $('#upload-barcode-input')[0].click();    
                    }, 500);
                    break;
                case 'device':
                    this.scanMode = BarcodeScanModes.Device;
                    this.focusImportTextarea();
                    this.$timeout(() => {
                        this.closeQuagga();
                    },1);
                    break;
                case 'camera':
                    this.scanMode = BarcodeScanModes.Camera;
                    this.$timeout(() => {
                        this.openQuagga();
                    },1);
                    break;
                default:
                    return;
            }
            this.localStorageItem.mode = this.scanMode;
            this.saveLocalStorageItem();
            this.barcodeScanModeChange();
        }

        inventoryTypeChange = () => {
            this.onInventoryTypeChange({inventoryType:this.currentInventoryType});
        }

        barcodeScanModeChange = () => {
            this.onBarcodeScanModeChange({scanMode:this.scanMode});
        }

        processFoundBarcode = (foundCode: string) => {
            var key = this.localStorageKey + this.localStorageCodeSuffix;
            var codes = [];
            try {
                codes = JSON.parse(sessionStorage.getItem(key)) || [];
            } catch (e) { }
            
            if (!codes.some(x => x == foundCode)) {
                codes.push(foundCode);
                try {
                    sessionStorage.setItem(key, JSON.stringify(codes));    
                } catch (e) { }
                
                
                // don't spam sounds and haptic feedback
                if (codes.length == 1) {
                    this.beepSound.play();
                    if (navigator.vibrate) {
                        navigator.vibrate(200);
                    }
                    // invoke registered callback
                    var vm = this;
                    this.$timeout(() => {
                        if (codes.length > 0) {
                            vm.onScan({codes: codes});
                        }                            
                    }, 1000);
                }
                
                // recycle previously found codes
                this.$timeout(() => {
                    try {
                        codes = JSON.parse(sessionStorage.getItem(key)) || [];
                        codes.splice(codes.indexOf(foundCode), 1);
                        sessionStorage.setItem(key, JSON.stringify(codes));        
                    } catch (e) { }
                }, 3000);    
            }


        }
        
        addBarcodesButtonClick = (e: any) => {
            if (!this.barcodeLookups) return;
            console.log('addBarcodesButtonClick', this.barcodeLookups);
            this.onScan( { codes: this.barcodeLookups.replace(/(^[ \t]*\n)/gm, "").split(/\r?\n/), mode: this.scanMode });
            this.clearBarCodeScanResults();
        }

        clearBarCodeScanResults = () => {
            this.barcodeLookups = null;
        }
        removeAllChildNodes = (parent) => {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        }


        /**
         * Bar code scanning image changed
         * */
         public imageChanged(file): ng.IPromise<boolean> {
            console.log('image changed', file)
            var deferred = this.$q.defer<boolean>();

            if (file) {
                this.barImage = file;
                this.decodeImage(file, deferred, 0, 0);
            }
            else {
                deferred.resolve(false);
            }

            return deferred.promise.finally(() => {
                
            });
        }

        private decodeImage(file, deferred, sizeNdx, readerNdx) {
            this.tryDecodeImage(file, sizeNdx, readerNdx)
                .then((response: IDecoderResponse) => {
                    this.processFoundBarcode(response.code);
                })
                .catch(() => {
                    this.failSound.play();
                    deferred.resolve(false);
                });
        }

        /**
         * Perform up to five attempts to find bar code on the supplied image
         * @param {any} file
         * @param {number} i - iterator
         * @param {ng.IDeferred} [deferred]
         * @returns {ng.IPromise<string>}
         * */
         private tryDecodeImage(file, sizeNdx = 0, readerNdx = 0, deferred?): ng.IPromise<IDecoderResponse> {
            let updatedConfig,
                locator,
                decoder;

            if (typeof deferred === 'undefined') {
                deferred = this.$q.defer();
            }

            if (readerNdx >= this.readers.length) {
                readerNdx = 0;
                ++sizeNdx;
            }

            if (sizeNdx >= this.decodeOrder.length) {
                return deferred.reject();
            }

            decoder = angular.extend({}, quaggaConfig.decoder, { readers: this.readers });
            locator = angular.extend({}, quaggaConfig.locator, { patchSize: this.decodeOrder[sizeNdx]});
            updatedConfig = angular.extend({}, quaggaConfig, {
                src: URL.createObjectURL(file),
                locator,
                decoder
            });

            Quagga.decodeSingle(updatedConfig, (result) => {
                if (result && result.codeResult && result.codeResult.code) {
                    var obj: IDecoderResponse = { code: result.codeResult.code, readerNdx: readerNdx, sizeNdx: sizeNdx };
                    deferred.resolve(obj);
                } else {
                    this.tryDecodeImage(file, sizeNdx, (readerNdx + 1), deferred);
                }
            });

            return deferred.promise;
        }

    };

    const quaggaConfig = {
        inputStream: {
            size: 800
        },
        locator: {
            patchSize: "medium",
            halfSample: false
        },
        numOfWorkers: navigator.hardwareConcurrency > 4 ? 4 : navigator.hardwareConcurrency,
        decoder: {
            readers: []
        },
        locate: true,
        src: null
    };

    interface IDecoderResponse {
        code: string;
        readerNdx: number;
        sizeNdx: number;
    };

    angular.module('meevo.components.controls')
        .component('meevoBarcodeScanner', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/barcodeScanner/barcodeScanner.template.html',
            controller: ['$scope', '$q', '$timeout', MeevoBarcodeScanner],
            controllerAs: 'vm',
            bindings: {
                scannerElement: '=',
                draggable: '=',
                currentInventoryType: '=',
                savedInventoryType: '=',
                context: '=',
                onDestroy: '&',
                onScan: '&',
                onInventoryTypeChange: '&',
                onBarcodeScanModeChange: '&'
            }
        });

}
